import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch } from 'vue';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { useStartPageJwtvExperiment } from '@/components/experiments/startPageJwtv';
import { useActivateExperiment, useExperiment } from '@/libraries/experiment';
import { until } from '@vueuse/core';

export default /*#__PURE__*/_defineComponent({
  __name: 'StartPageJwtvContainer',
  setup(__props) {

const StartPageJwtvOverlay = () =>
	import(
		/* webpackChunkName: "start-page-jwtv-overlay" */ '@/components/experiments/startPageJwtv/StartPageJwtvOverlay.vue'
	);
const routingStore = useRoutingStore();

const { experimentInfo } = useExperiment('EXP_START_PAGE_JWTV');
const { isOverlayDismissed, overlayUnlocked } = useStartPageJwtvExperiment();

const condition = computed(() =>
	experimentInfo.value.variant === 'variant_2'
		? !isOverlayDismissed.value
		: routingStore.pageType === 'VIEW_HOME_GLOBAL'
);
const { activeVariant, activeVariantWithControlGroup, trackEvent } = useActivateExperiment(
	'EXP_START_PAGE_JWTV',
	condition
);

const showOverlay = computed(
	() => activeVariant.value === 'variant_2' && overlayUnlocked.value && !isOverlayDismissed.value
);

onMounted(async () => {
	await until(() => activeVariantWithControlGroup.value).toBeTruthy();
	watch(
		() => activeVariantWithControlGroup.value,
		newVal => {
			if (newVal) {
				trackEvent({
					action: 'impression',
				});
			}
		},
		{ immediate: true }
	);
});

return { __sfc: true,StartPageJwtvOverlay, routingStore, experimentInfo, isOverlayDismissed, overlayUnlocked, condition, activeVariant, activeVariantWithControlGroup, trackEvent, showOverlay }
}

})